function configAutocomplete() {
	function set_auto_complete(keyword, el_id) {
		//console.log('set_auto_complete ' + keyword);
		var $el;

		if(el_id == undefined) {
			$el = $(".ac-" + keyword);
		} else {
			$el = $(el_id);
		}

		// autocomplete
		$el.each(function() {
			var $this = $(this);

			$this.autocomplete({
				source: function(request, response) {
							$.ajax({
								url: baseurl + 'admin/' + keyword + '/get_json',
								data: { item: request.term },
								dataType: "json",
								type: "POST",
								success: function(data) {
									response(data);
								}
							});
						},
				select: function(event, ui) {
							//console.log(ui.item.label);
							var target = $this.attr('data-target');

							$this.val(ui.item.label);
							$("#"+target).val(ui.item.value).trigger('change');

							//console.log("#"+target);

							event.preventDefault();
						},
				minLength: 3
			});
		});

	}
	
	// autocomplete

	set_auto_complete('cidades');
	set_auto_complete('caracteristicas');
	set_auto_complete('cadastros');
	set_auto_complete('corretores');
	set_auto_complete('sa_clientes');
}

export default configAutocomplete
